<template>
  <BasePopup :show="show" @close="$emit('close')" close-test-id="intro-close" card-class="w-full max-w-lg p-6 pt-4">
    <div class="flex items-center mb-4 pr-10">
      <h3 class="text-[20px] font-bold text-black tracking-[-0.01em]">Prenota una videochiamata gratuita</h3>
    </div>

    <img
      v-if="heroImage"
      data-testid="intro-hero"
      :src="heroImage"
      alt=""
      class="w-full h-48 object-cover rounded-[25px] mt-2 mb-4"
    />
    <div v-else class="w-full h-48 bg-gray-100 rounded-[25px] mt-2 mb-4"></div>

    <p class="text-[16px] leading-[26px] text-[#585858] font-medium mb-8">
      {{ bodyText }}
      <span class="text-[#489B79]">È gratuita!</span>
    </p>

    <label class="ic-field__label block mb-2" for="intro-email">
      Inserisci l'E-mail per iniziare
    </label>
    <div class="flex gap-3">
      <input
        id="intro-email"
        data-testid="intro-email"
        v-model="email"
        type="email"
        class="ic-field__input flex-1"
      />
      <button
        type="button"
        data-testid="intro-start"
        class="rounded-[9px] w-[110px] text-[15px] bg-[#489B79] text-white font-bold shrink-0"
        @click="start"
      >
        Inizia
      </button>
    </div>
    <p v-if="errorMsg" data-testid="intro-error" class="text-sm text-red-600 mt-2">{{ errorMsg }}</p>
  </BasePopup>
</template>

<script>
import BasePopup from "@/components/BasePopup.vue";

function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

export default {
  name: "IntroEmailGate",
  components: { BasePopup },
  props: {
    show: { type: Boolean, default: false },
    heroImage: { type: String, default: "" },
    bodyText: {
      type: String,
      default:
        "Richiedi una videochiamata di 30 minuti con un progettista certificato, per discutere del progetto di ristrutturazione di questo annuncio.",
    },
  },
  emits: ["close", "start"],
  data() {
    return { email: "", errorMsg: "" };
  },
  watch: {
    show(val) {
      if (val) {
        this.errorMsg = "";
      }
    },
  },
  methods: {
    start() {
      this.errorMsg = "";
      const email = (this.email || "").trim().toLowerCase();
      if (!isValidEmail(email)) {
        this.errorMsg = "Inserisci un indirizzo email valido.";
        return;
      }
      this.$emit("start", email);
    },
  },
};
</script>
